export function StatusBadge(props: { status: string }) {
  const color =
    props.status === "active" || props.status === "approved" ? "bg-emerald-900/40 text-emerald-300 border-emerald-700"
    : props.status === "pending" ? "bg-amber-900/40 text-amber-300 border-amber-700"
    : "bg-gray-800 text-gray-400 border-gray-700";
  return <span class={`px-2 py-0.5 text-xs rounded border ${color}`}>{props.status}</span>;
}
